import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { DEFAULT_SCALE_RANGE } from "../../modules/Style/constants";
import { setDefaultScaleRange, setScaleSegments } from "../../ducks/style/style";
import { getDefaultScaleRange, getScaleSegments } from "../../ducks/style/selectors";
import { getAppConfig } from "../../ducks/appConfig";

export const useDefaultScaleRange = () => {
  const dispatch = useDispatch();
  const defaultScaleRange = useSelector(getDefaultScaleRange);
  const scaleSegments = useSelector(getScaleSegments);
  const { settings } = useSelector(getAppConfig);

  useEffect(() => {
    if (!settings) return;

    const { defaultScaleRange: defaultScaleRangeSetting } = settings;

    if (defaultScaleRangeSetting) {
      if (
        defaultScaleRangeSetting[0] !== defaultScaleRange[0] ||
        defaultScaleRangeSetting[1] !== defaultScaleRange[1]
      ) {
        dispatch(setDefaultScaleRange(defaultScaleRangeSetting));
      }

      if (!scaleSegments) {
        dispatch(setScaleSegments(defaultScaleRangeSetting));
      }
    }
  }, [settings]);

  return settings?.defaultScaleRange || DEFAULT_SCALE_RANGE;
};
